module.exports = __webpack_public_path__ + "static/media/36.3500c768.wav";